export default __webpack_public_path__ + "static/media/fs-ii-merchandising.53731253.svg";